import { useThemeCustomization } from "@/hooks/useThemeCustomization";

interface BrandLogoProps {
  appName?: string | null;
}

export const BrandLogo = ({ appName }: BrandLogoProps = {}) => {
  const { logoUrl, brandName } = useThemeCustomization(appName);
  
  return (
    <div className="flex flex-col items-center mb-8">
      <div className="mb-6">
        <img 
          src={logoUrl}
          alt={`${brandName} Logo`}
          className="h-32 w-auto mb-4 object-contain"
        />
      </div>
      <h1 className="text-3xl font-bold mb-2">
        {/* <span className="text-primary">{brandName}</span> */}
      </h1>
    </div>
  );
};
